export enum GalleryMode {
  grid = "GRID",
  feed = "FEED",
}

export enum GuestPageTab {
  gallery = "gallery",
  guestbook = "guestbook",
}
